import { render, staticRenderFns } from "./RoleTabs.vue?vue&type=template&id=6c0396a5&"
import script from "./RoleTabs.vue?vue&type=script&lang=js&"
export * from "./RoleTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports